/**
 *
 * ResultsItem
 *
 */

import React, { memo, FunctionComponent } from 'react';
import helmetIcon from '../../../../assets/icons/helmet.svg';
import horseIcon from '../../../../assets/icons/horse.svg';
import { EventType, JudgeNamePosition, LiveFeedEventResult } from '../../../../domain';

interface IProps {
  result: LiveFeedEventResult;
  judges?: JudgeNamePosition[];
  type?: EventType;
  disabledFields: string[];
}

const ResultsItem: FunctionComponent<IProps> = ({
  result,
  judges = [],
  type,
  disabledFields,
}) => {
  // const { ref, width = 0 } = useResizeObserver();

  const isEnabled = (field: string) => {
    return !disabledFields.includes(field);
  };

  return (
    <tr>
      <td>{isEnabled('eaEventClassAndSort') && result.eaEventClassAndSort}</td>
      <td>{isEnabled('sectionName') && result.sectionName}</td>
      <td>{isEnabled('bridleNumber') && <div>{result.bridleNumber}</div>}</td>
      <td>
        <div className="d-flex align-items-center">
          <img src={helmetIcon} className="mr-11 tablet-hidden" alt="" />
          <div className="fs-12 fw-7">
            {result.riderFirstName} {result.riderLastName}{' '}
          </div>
        </div>
        <div className="tablet-visible">
          {result.customHorseName || result.horseName}
        </div>
      </td>
      <td className="horse-detailed">
        <div className="d-flex align-items-center tablet-hidden">
          <img src={horseIcon} className="mr-11" alt="" />
          <div className="d-flex flex-column">
            <div className="fs-12 fw-7">
              {result.customHorseName || result.horseName}
            </div>
            <div className="fs-12 txt-secondary">
              Owner: {result.ownerFirstName} {result.ownerLastName}{' '}
            </div>
          </div>
        </div>
      </td>
      <td className="tablet-hidden">
        {isEnabled('dressageTime') && <div>{result.dressageTime}</div>}
      </td>
      {judges.length > 1 &&
        judges.map((judge, index) => (
          <td key={index}>
            {isEnabled(`judgeScore${index + 1}`) && (
              <div>{result.judgeScores?.[index]}</div>
            )}
          </td>
        ))}
      <td>
        {isEnabled('dressageScore') && (
          <div>{result.dressageScore?.toFixed(2)}</div>
        )}
      </td>
      <td>
        {isEnabled('dressageCollective') && (
          <div>{result.dressageCollective?.toFixed(2)}</div>
        )}
      </td>
      <td>
        {isEnabled('eaDressagePercentageCustom') && (
          <div>{result.eaDressagePercentageCustom?.toFixed(3)}</div>
        )}
      </td>
      <td>
        {isEnabled('sectionPlace') && (
          <div className="fw-7">{result.sectionPlace}</div>
        )}
      </td>
      <td>
        {isEnabled('overallPlace') && (
          <div className="fw-7">{result.overallPlace}</div>
        )}
      </td>
      <td>
        {isEnabled('riderClassStatusCode') && (
          <div className="fw-7 fs-12">{result.riderClassStatusCode}</div>
        )}
      </td>
    </tr>
  );
};

export default memo(ResultsItem);
